export default class DimensionHandler {


  public static defaultPixelsPer = 96;

  public static convertToPixels(dimensions: object | Array<number> | number,
                                pixelsPer: number = DimensionHandler.defaultPixelsPer,
                                scale: number = 1) {
    if (!dimensions) return;
    const coefficient = pixelsPer * scale;
    if (Object.keys(dimensions).length) {
      const converted = {};
      Object.keys(dimensions).forEach(key => {
        converted[key] = dimensions[key] * coefficient
      });
      return converted;
    } else if (dimensions instanceof Array) {
      return dimensions.map(val => { return val * coefficient })
    } else if (typeof dimensions === 'number') {
      return dimensions * coefficient
    }
  }
}